import appendEmailBoilerplate from "@app/util/email/appendEmailBoilerplate";
import appendEmailSignature from "@app/util/email/appendEmailSignature";

export interface EmailComposeText {
  boilerplateText: string;
  signatureText: string;
}

// The one owner of what a send_email proposal's body becomes. The apply serializer and the card's
// read-only preview both call it, so the rep reads the same HTML the platform receives — without
// this they drifted, and an untouched proposal previewed bare agent text while sending text with a
// signature block and the org footer.
//
// A draft body already holds the signature as the rep left it, deleted included, so the seed is
// reproduced only when there is no draft. The boilerplate is appended either way, because the
// composer keeps it as a locked block the rep never edits.
const composeSendEmailBody = (
  proposalBody: string,
  draftBody: unknown,
  { boilerplateText, signatureText }: EmailComposeText
): string =>
  appendEmailBoilerplate(
    typeof draftBody === "string" ? draftBody : appendEmailSignature(proposalBody, signatureText),
    boilerplateText
  );

export default composeSendEmailBody;
